<template>
    <div id="app" :style="screenWidth < 1000 ? 'width: 1000px;' : 'width: 100%;'">
        <div class="top">
            <div class="long">
                <img src="@/Img/logo.png" alt="" />
                <div
                    class="logotxtx"
                    :style="screenWidth < 1800 ? 'font-size: 30px;' : 'font-size: 35px;'"
                >
                    <p class="p1">贵阳市第四人民医院</p>
                    <p class="p2">贵阳市骨科医院</p>
                </div>
            </div>
            <div class="search">
                <input type="text" v-model="search" placeholder="输入搜索关键词" />
                <div class="btn" @click="onsearch">
                    <i class="el-icon-search"></i>
                </div>
            </div>
            <i v-if="screenWidth < 1800" class="el-icon-s-unfold btn_icon" @click="btnicon"></i>
        </div>
        <div style="width: 100%; border-top: solid 1px #d1d1d1"></div>
        <div class="navigation" v-if="screenWidth > 1800">
            <el-menu class="el-menu-demo" active-text-color="#1d938d" mode="horizontal">
                <el-menu-item index="1" @click="home">网站首页</el-menu-item>
                <el-submenu v-for="item in newslist" :index="item.value" :key="item.value">
                    <template slot="title" style="color: aqua">
                        {{ item.label }}
                    </template>
                    <el-menu-item
                        style="text-align: center; font-size: 20px"
                        v-for="news in item.children"
                        :key="news.value"
                        :index="news.value"
                        @click="tolist(news, item)"
                    >
                        {{ news.label }}
                    </el-menu-item>
                </el-submenu>
            </el-menu>
        </div>

        <div class="navigationyd" v-else>
            <el-menu class="el-menu-demo" v-if="news" active-text-color="#1d938d" mode="vertical">
                <el-menu-item index="1" @click="home">网站首页</el-menu-item>
                <el-submenu v-for="item in newslist" :index="item.value" :key="item.value">
                    <template slot="title">{{ item.label }}</template>
                    <el-menu-item
                        style="text-align: center; font-size: 20px"
                        v-for="news in item.children"
                        :key="news.value"
                        :index="news.value"
                        @click="tolist(news, item)"
                    >
                        {{ news.label }}
                    </el-menu-item>
                </el-submenu>
            </el-menu>
        </div>
        <div class="fudong">
            <p @click="clickzp">院内招聘</p>
            <p @click="clickgs">招标公告</p>
        </div>
        <router-view />
    </div>
</template>
<script>
export default {
    data() {
        return {
            search: '',
            newslist: [],
            screenWidth: '', // 屏幕尺寸
            news: false,
        };
    },
    created() {
        //导航http://113.125.39.38:8080/renren-fast/index/news/selectCategoryData
        this.$http
            .get('news/selectCategoryData', {
                params: {
                    start: 0,
                    end: 100,
                },
            })
            .then(res => {
                this.newslist = res.data;
                // console.log('导航', this.newslist);
            });
    },
    mounted() {
        //获取屏幕尺寸
        this.screenWidth = document.body.clientWidth;
        window.onresize = () => {
            console.log('高度');
            //屏幕尺寸变化
            return (() => {
                this.screenWidth = document.body.clientWidth;
            })();
        };
    },

    watch: {
        screenWidth: function (n, o) {
            console.log('k', n);
            if (n <= 1700) {
                console.log('屏幕宽度小于1200了');
                // 例隐藏body滚动条

                // 通过class类名设置样式
                let byClass = document.getElementsByClassName('el-submenu__title').style;
                console.log('byClass', byClass);
            } else {
                console.log('屏幕宽度没有小于1200');
            }
        },
    },
    methods: {
        tolist(news, item) {
            // console.log('1111', news, '22', item);
            this.news = !this.news;
            if (news.type == '详情') {
                this.$router.push('/details?id=' + news.value);
            } else {
                this.$router.push('/list?id=' + item.value + '&news=' + news.value);
            }
        },
        clickzp() {
            this.$router.push('/list?id=6&news=36');
        },
        clickgs() {
            this.$router.push('/list?id=6&news=37');
        },
        home() {
            this.news = !this.news;
            this.$router.push('/');
        },
        btnicon() {
            this.news = !this.news;
        },
        onsearch() {
            // console.log(this.search);
            if (this.search) {
                this.$router.push('/search?param=' + this.search);
            } else {
                // console.log('11');
            }
        },
    },
};
</script>
<style lang="less">
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-family: '微软雅黑';
    font-size: 16px;
    width: 100%;
    height: 100%;

    .top {
        width: 90%;
        height: 200px;
        margin: auto;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .long {
            display: flex;
            img {
                width: 97px;
                height: 97px;
            }
            .logotxtx {
                font-size: 35px;
                font-weight: normal;
                font-stretch: normal;
                color: #1d938d;
                .p1 {
                    font-family: SourceHanSansSC-Regular;
                    letter-spacing: 1px;
                }
                .p2 {
                    font-family: SourceHanSansSC-Normal;
                    letter-spacing: 13px;
                }
            }
        }
        .search {
            height: 81px;
            display: flex;
            input {
                font-size: 20px;
                padding: 0 5px;
                border: 2px solid #d1d1d1;
            }
            .btn {
                width: 85px;
                height: 80px;
                background-color: #1d938d;
                display: flex;
                align-items: center;
                i {
                    font-size: 40px;
                    color: #fff;
                    margin: auto;
                }
            }
        }
    }
    .btn_icon {
        font-size: 60px;
    }
    .navigation {
        width: 100%;
        height: 100px;
        ul {
            display: flex;
            justify-content: space-around;
            text-align: center !important;
        }
        .el-menu.el-menu--horizontal {
            border-bottom: none;
        }
        .el-menu-item {
            font-family: SourceHanSansSC-Regular;
            font-size: 24px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 100px;
            letter-spacing: 1px;
            color: #282828;
            height: 81px;
            border-bottom: 2px solid #1d938d;
        }
        .el-submenu__title {
            font-family: SourceHanSansSC-Regular;
            font-size: 24px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 100px;
            letter-spacing: 1px;
            color: #282828;
            height: 81px;
            border-bottom: 2px solid #1d938d;
        }
    }
    .navigationyd {
        width: 100%;
        position: absolute;
        z-index: 999;
        ul {
            width: 100%;
            text-align: center !important;
        }
        .el-menu.el-menu--horizontal {
            border-bottom: none;
        }
        .el-menu-item {
            font-family: SourceHanSansSC-Regular;
            font-size: 26px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 100px;
            letter-spacing: 1px;
            color: #282828;
            height: 81px;
            border-bottom: 2px solid #1d938d;
        }
        .el-submenu__title {
            font-family: SourceHanSansSC-Regular;
            font-size: 26px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 100px;
            letter-spacing: 1px;
            color: #282828;
            height: 81px;
            border-bottom: 2px solid #1d938d;
        }
    }
    .fudong {
        width: 150px;
        height: 100px;
        position: fixed;
        top: 300px;
        right: 20px;
        background-color: rgba(#1d938d, 0.8);
        z-index: 99;
        font-size: 20px;
        border-radius: 5px;
        line-height: 40px;
        text-align: center;
        color: #fff;
        cursor: pointer;
    }
}
</style>
